import { selectAll } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class InfoCarousel {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.tabButtonEl = selectAll('[data-tab]');
    this.infoCarouselEl = selectAll("[data-info-carousel]");
    this.section = selectAll('[data-section]');
    this.infograph = selectAll('[data-infograph]');
    this.svg = selectAll('[data-svg] g');
  }

  render() {
    this.teamCarousel();
    this.tabButton();
    this.infographChange();
  }

  tabButton = () => {
    for(let tabButton of this.tabButtonEl) {
      tabButton.addEventListener('click', () => {
        tabButton.closest('.js-tabs').querySelector('.active').classList.remove('active');
        tabButton.classList.add('active');
        Array.from(this.section).map((section) => {
          tabButton.dataset.tab === section.dataset.section ? section.classList.remove('hide') : section.classList.add('hide');
        })
      })
    }
  }

  teamCarousel = () => {
    const windowWidth = window.matchMedia("(min-width:1025px");

    for (var i = 0; i < this.infoCarouselEl.length; i++) {
      let slider = new Swiper(this.infoCarouselEl[i], {
        spaceBetween: 24,
        slidesPerView: 'auto',
        centeredSlides: true,
        slideToClickedSlide: true,
      });

      slider.on('activeIndexChange', () => {
        console.log(slider.activeIndex);
        console.log(slider.slides[slider.realIndex]);
        slider.$wrapperEl[0].querySelector('.show').classList.remove('show');
        slider.slides[slider.realIndex].classList.add('show');
        // slider.clickedSlide.classList.add('show');
      })

      if (windowWidth.matches) {
        slider.disable();
      }
      else{
        slider.enable();
      }
  
      windowWidth.addListener((e) => {
        if (e.matches) {
          slider.disable();
        }
        else{
          slider.enable();
        }
      });
    };
  };

  infographChange = () => {
    let that = this;

    let observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutationRecord) {
        if (mutationRecord.target.classList.contains("show")) {
          console.log(mutationRecord.target.dataset.infograph)
          Array.from(that.svg).map((icons) => {
            icons.getAttribute('id') === mutationRecord.target.dataset.infograph ? icons.classList.add('active') : icons.classList.remove('active');
          })
        } 
    })
  });

  for(let info of this.infograph) {
    info.addEventListener('click',() => {
      info.closest('.swiper-wrapper').querySelector('.show').classList.remove('show');
      info.classList.add('show');
    })
    observer.observe(info, {
      attributes : true,
      attributeFilter : ['style', 'class']
      });
    }
  }
}